<template>
  <transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/components/User/Rincian-Bayar/index.vue